import React, { useState, useContext } from 'react';
import QuickView from '../models/QuickView'
import { useFetch, Items } from '@thinkwell/react.common'

const QuickViewsContext = React.createContext([[], () => {}, {}, () => {}, () => {}, () => {}]);

const QuickViewsProvider = (props) => {

  const quickViews = (props.value || []).map((c) => QuickView(c))
  const [items, setItems, upsertItem, getItem, deleteItem] = Items(useState(quickViews))

  const setQuickViews = (items) => {
    const quickViews = items.map((i) => QuickView(i))
    setItems(quickViews)
  }
  const [fetchQuickViewsState, fetchQuickViews] = useFetch({onSuccess: setQuickViews})

  const upsertQuickView = (item) => {
    upsertItem(QuickView(item))
  }

  return (
    <QuickViewsContext.Provider value={[items, fetchQuickViews, fetchQuickViewsState, upsertQuickView, getItem, deleteItem]}>
      {props.children}
    </QuickViewsContext.Provider>
  );
};

export { QuickViewsContext, QuickViewsProvider}
